import { useUrlPersistedDashState } from "./use-url-persisted-state"

/**
 * Render-only marker that activates URL persistence for the surrounding
 * DashboardStateProvider subtree. Mount once near the top of a
 * dashboard; renders nothing.
 *
 * Defaulting to enabled means filter state survives a refresh and
 * shared URLs reproduce the filter view. Mini-previews mount this
 * component with `enabled={false}` so preview tiles don't leak state
 * into the live URL.
 */
export function DashboardUrlStateSync({ enabled }: { enabled?: boolean }) {
  useUrlPersistedDashState({ enabled })
  return null
}
